import { render, staticRenderFns } from "./HeaderPage.vue?vue&type=template&id=dcaf8ec6&scoped=true&"
import script from "./HeaderPage.vue?vue&type=script&lang=js&"
export * from "./HeaderPage.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPage.vue?vue&type=style&index=0&id=dcaf8ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaf8ec6",
  null
  
)

component.options.__file = "HeaderPage.vue"
export default component.exports